var audio_rtlignore_default = {
  "fontElementMap": "crkog",
  "container": "c0VTC",
  "customPlayer": "_7ew-F",
  "slim": "plpbC",
  "playPauseButton": "Ekp7E",
  "coverImage": "_2SwdF",
  "trackDetailsContainer": "_2XYSh",
  "controlsContainer": "NiqHD",
  "controlsGroup": "_4VFec",
  "sliderContainer": "_8qv5j",
  "audioDuration": "AiWfw",
  "isLoading": "aOmyX",
  "audioDetails": "IByG8",
  "authorName": "rQyvs",
  "title": "M8NBZ",
  "dropdownMenuWrapper": "kSDb2",
  "dropdownSelectedButton": "_2Rk6D",
  "dropdownContent": "zG3Ni",
  "dropdownContentWithIcon": "aQ9S4",
  "audioLoader": "XoggI"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
